module.exports = "/static/images/jet-ski-2.jpg";